import React from 'react'
import { toJS } from 'mobx'
import './index.scss'

//api
import { api } from '../../../../functions/api'

//other libraries
import { inject, observer } from 'mobx-react'
import { clone } from 'lodash'


//material-ui
import { CardContent, FormControl, Grid, InputLabel } from '@material-ui/core'
import Select from '@material-ui/core/Select'
import MenuItem from '@material-ui/core/MenuItem'
import Card from '@material-ui/core/Card'
import CircularProgress from '@material-ui/core/CircularProgress'

//custom components

@inject('internal')
@inject('translate')
@observer
export default class ProductVignettes extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      vignettes: [],
      energyClasses: [],
      firstEnergyClass: null,
      secondEnergyClass: null,
      productVignettes: [],
      updatingProductVignettes: false,
    }
  }
  
  componentDidMount() {
    this.setState({
      productVignettes: toJS(this.props.internal.dataForSimpeTable.vignettes),
      firstEnergyClass: toJS(this.props.internal.dataForSimpeTable.first_energy_class_id),
      secondEnergyClass: toJS(this.props.internal.dataForSimpeTable.second_energy_class_id),
    })
    
    this.loadVignettes()
    this.loadEnergyClasses()
  }
  
  loadVignettes = () => {
    api({
      method: 'GET',
      url: `products/vignettes`,
      authorization: this.props.internal.user.access_token,
    }).then(result => {
      if (true === result.success) {
        this.setState({ vignettes: result.data.data.vignettes })
      }
    })
  }
  
  loadEnergyClasses = () => {
    api({
      method: 'GET',
      url: `products/energy-classes`,
      authorization: this.props.internal.user.access_token,
    }).then(result => {
      if (true === result.success) {
        this.setState({ energyClasses: result.data.data.classes })
      }
    })
  }
  
  updateVignettes = () => {
    let idProduct = this.props.routerData.match.params.idProduct
    
    const { productVignettes } = this.state
    
    let params = {
      vignettes: productVignettes.map(vignette => ({ vignette_id: vignette.id, position: vignette.position })),
    }
    
    return api({
      method: 'PATCH',
      url: `products/${idProduct}/pair-vignettes`,
      authorization: this.props.internal.user.access_token,
      params: params,
    })
  }
  
  updateProduct = () => {
    let idProduct = this.props.routerData.match.params.idProduct
    
    const { firstEnergyClass, secondEnergyClass } = this.state
    
    let params = {
      first_energy_class_id: firstEnergyClass,
      second_energy_class_id: secondEnergyClass,
    }
    
    return api({
      method: 'PATCH',
      url: `products/${idProduct}`,
      authorization: this.props.internal.user.access_token,
      params: params,
    })
  }
  
  changeVignette = (position, event) => {
    const { updatingProductVignettes, productVignettes, vignettes } = this.state
    
    if (true === updatingProductVignettes) {
      return
    }
    
    const vignette_id = event.target.value
    
    const vignetteIndex = productVignettes.findIndex(vignette => vignette.position === position)
    
    if (vignette_id === '') {
      if (vignetteIndex > -1) {
        productVignettes.splice(vignetteIndex, 1)
      }
    } else {
      const productVignette = clone(vignettes.find(vignette => vignette.id === vignette_id))
      productVignette.position = position
      
      if (vignetteIndex > -1) {
        productVignettes.splice(vignetteIndex, 1, productVignette)
      } else {
        productVignettes.push(productVignette)
      }
    }
    
    this.setState({ productVignettes, updatingProductVignettes: true }, () => {
      this.updateVignettes().then(result => {
        this.setState({ updatingProductVignettes: false })
        if (result.success) {
          this.props.internal.setSnackbar(result.data.message, true)
        }
      })
    })
  }
  
  changeEnergyClass = (position, event) => {
    this.setState({ [position]: event.target.value, updatingProductVignettes: true }, () => {
      this.updateProduct().then(result => {
        this.setState({ updatingProductVignettes: false })
        if (result.success) {
          this.props.internal.setSnackbar(result.data.message, true)
        }
      })
    })
  }
  
  render() {
    const { vignettes, productVignettes, updatingProductVignettes, energyClasses, firstEnergyClass, secondEnergyClass } = this.state
    
    const topLeftVignette = productVignettes.filter(vignette => vignette.position === 'top-left')[0]
    const topRightVignette = productVignettes.filter(vignette => vignette.position === 'top-right')[0]
    const bottomLeftVignette = productVignettes.filter(vignette => vignette.position === 'bottom-left')[0]
    const bottomRightVignette = productVignettes.filter(vignette => vignette.position === 'bottom-right')[0]
    
    return (
      <React.Fragment>
        {updatingProductVignettes ? <CircularProgress className={'circular-progress'}/> : (
          <React.Fragment>
            <Card className={'mt-20'}>
              <CardContent>
                <Grid container spacing={24}>
                  <Grid item sm={12} md={6}>
                    <FormControl fullWidth>
                      <InputLabel htmlFor={'vignette_top_left'}>{this.props.translate.i18n.MODULES.PRODUCTS.VIGNETTE_TOP_LEFT}</InputLabel>
                      <Select
                        id={'vignette_top_left'}
                        value={topLeftVignette ? topLeftVignette.id : ''}
                        onChange={e => this.changeVignette('top-left', e)}
                      >
                        <MenuItem value="">
                          <em>{this.props.translate.i18n.GLOBAL.SELECT}</em>
                        </MenuItem>
                        {vignettes && vignettes.length > 0 && vignettes.map(vignette => (
                          <MenuItem value={vignette.id} key={vignette.id}>
                            {vignette.name}
                          </MenuItem>
                        ))}
                      </Select>
                    </FormControl>
                  </Grid>
                  <Grid item sm={12} md={6}>
                    <FormControl fullWidth>
                      <InputLabel htmlFor={'vignette_top_right'}>{this.props.translate.i18n.MODULES.PRODUCTS.VIGNETTE_TOP_RIGHT}</InputLabel>
                      <Select
                        id={'vignette_top_right'}
                        value={topRightVignette ? topRightVignette.id : ''}
                        onChange={e => this.changeVignette('top-right', e)}
                      >
                        <MenuItem value="">
                          <em>{this.props.translate.i18n.GLOBAL.SELECT}</em>
                        </MenuItem>
                        {vignettes && vignettes.length > 0 && vignettes.map(vignette => (
                          <MenuItem value={vignette.id} key={vignette.id}>
                            {vignette.name}
                          </MenuItem>
                        ))}
                      </Select>
                    </FormControl>
                  </Grid>
                  <Grid item sm={12} md={6}>
                    <FormControl fullWidth>
                      <InputLabel htmlFor={'vignette_bottom_left'}>{this.props.translate.i18n.MODULES.PRODUCTS.VIGNETTE_BOTTOM_LEFT}</InputLabel>
                      <Select
                        id={'vignette_bottom_left'}
                        value={bottomLeftVignette ? bottomLeftVignette.id : ''}
                        onChange={e => this.changeVignette('bottom-left', e)}
                      >
                        <MenuItem value="">
                          <em>{this.props.translate.i18n.GLOBAL.SELECT}</em>
                        </MenuItem>
                        {vignettes && vignettes.length > 0 && vignettes.map(vignette => (
                          <MenuItem value={vignette.id} key={vignette.id}>
                            {vignette.name}
                          </MenuItem>
                        ))}
                      </Select>
                    </FormControl>
                  </Grid>
                  <Grid item sm={12} md={6}>
                    <FormControl fullWidth>
                      <InputLabel htmlFor={'vignette_bottom_right'}>{this.props.translate.i18n.MODULES.PRODUCTS.VIGNETTE_BOTTOM_RIGHT}</InputLabel>
                      <Select
                        id={'vignette_bottom_right'}
                        value={bottomRightVignette ? bottomRightVignette.id : ''}
                        onChange={e => this.changeVignette('bottom-right', e)}
                      >
                        <MenuItem value="">
                          <em>{this.props.translate.i18n.GLOBAL.SELECT}</em>
                        </MenuItem>
                        {vignettes && vignettes.length > 0 && vignettes.map(vignette => (
                          <MenuItem value={vignette.id} key={vignette.id}>
                            {vignette.name}
                          </MenuItem>
                        ))}
                      </Select>
                    </FormControl>
                  </Grid>
                </Grid>
              </CardContent>
            </Card>
            <Card className={'mt-20'}>
              <CardContent>
                <Grid container spacing={24}>
                  <Grid item sm={12} md={6}>
                    <FormControl fullWidth>
                      <InputLabel htmlFor={'first_energy_class'}>{this.props.translate.i18n.MODULES.PRODUCTS.ENERGY_CLASS_1}</InputLabel>
                      <Select
                        id={'first_energy_class'}
                        value={firstEnergyClass || ''}
                        onChange={e => this.changeEnergyClass('firstEnergyClass', e)}
                      >
                        <MenuItem value="">
                          <em>{this.props.translate.i18n.GLOBAL.SELECT}</em>
                        </MenuItem>
                        {energyClasses && energyClasses.length > 0 && energyClasses.map(eclass => (
                          <MenuItem value={eclass.id} key={eclass.id}>
                            {eclass.name}
                          </MenuItem>
                        ))}
                      </Select>
                    </FormControl>
                  </Grid>
                  <Grid item sm={12} md={6}>
                    <FormControl fullWidth>
                      <InputLabel htmlFor={'vignette_top_right'}>{this.props.translate.i18n.MODULES.PRODUCTS.ENERGY_CLASS_2}</InputLabel>
                      <Select
                        id={'second_energy_class'}
                        value={secondEnergyClass || ''}
                        onChange={e => this.changeEnergyClass('secondEnergyClass', e)}
                      >
                        <MenuItem value="">
                          <em>{this.props.translate.i18n.GLOBAL.SELECT}</em>
                        </MenuItem>
                        {energyClasses && energyClasses.length > 0 && energyClasses.map(eclass => (
                          <MenuItem value={eclass.id} key={eclass.id}>
                            {eclass.name}
                          </MenuItem>
                        ))}
                      </Select>
                    </FormControl>
                  </Grid>
                </Grid>
              </CardContent>
            </Card>
          </React.Fragment>
        )}
      </React.Fragment>
    )
  }
  
}



// WEBPACK FOOTER //
// ./src/screens/products/edit/vignettes/index.js